<template>
  <div id="allDeviceDetail">
    <!-- 设备信息--设备信息图表、设备信息详情 -->
    <el-row :gutter="40" style="margin-bottom: 32px;">
      <el-col :xs="14" :sm="14" :lg="14" class="card-panel-col">
        <div class="card-panel">
          <p class="blockTitleP">
            <i class="el-icon-first-aid-kit" style="font-size: 24px;" />
            <span style="vertical-align: top;"> {{ basicinfo.batteryBrand }}/{{ basicinfo.batteryModel }}
              {{ basicinfo.batteryCapacity }} Ah</span>
            <el-button type="primary" icon="el-icon-data-line" class="deviceInfoDetailBtn" style="right: 20px;" @click="goToReport" />
          </p>
          <div class="blockContentDiv">
            <div class="deviceInfoChart" style="width:100%">
              <div style="position: absolute;bottom: 65px;z-index: 99; width: 120px;">
                <button class="changePieBtn firstBtn active" @click="changePieChart($event,1,0)">AH</button>
                <button class="changePieBtn secondBtn" @click="changePieChart($event,2,0)">{{ pieSeriesDataName }}</button>
              </div>
              <!-- 充放比 -->
              <!-- <p v-if="!pieSeriesData[0].value&&!pieSeriesData[1].value" style="text-align: center;line-height: 30px;position: relative;width: 100%;margin-top: 100px;">{{ $t("yhubReport.Nodata") }}</p> -->
              <div class="pieChartDiv" style="position: relative;">
                <chargedAndDisChart :series-data="pieSeriesData" :height="rateHeight" />
                <yhubPieChart1 class="myPieChartSecond" :height="rateHeight" :series-data="pieSeriesData2" style="display:none;" :color-arr="colorArr2" />
              </div>

              <!-- 问号弹窗 -->
              <!-- <div v-if="(pieSeriesData[0].value||pieSeriesData[1].value)&&showFirstPie" style="position: relative;">
                <div class="el-icon-question"
                  style="font-size:20px;position: absolute;bottom: 128px;left: 100px;color: #858585;"
                  @mouseover="mouseoverQuestion(0)" @mouseout="mouseoutQuestion(0)" />

                <div class="questionPop">
                  <p>{{ $t('allDeviceDetail.TotalChargeSinceInstallation') }}</p>
                </div>
              </div> -->

            </div>
          </div>
          <!-- <div class="blockContentDiv" style="justify-content: flex-end;"> -->
          <!-- <el-button type="primary" icon="el-icon-view" @click="goToReport" /> -->
          <!-- </div> -->
        </div>
      </el-col>
      <el-col :xs="10" :sm="10" :lg="10" class="card-panel-col">
        <div class="card-panel" style="padding-bottom: 5px;">
          <p class="blockTitleP">
            {{ basicinfo.deviceName }}
            <span v-show="isShowWarnIcon" class="redWarningRadiu" />
            <el-button v-if="basicinfo.customerServiceNum&&basicinfo.customerServiceNum>0" 
              class="feedBackBtn" type="primary" icon="el-icon-more" :title="$t('feedBack.deviceUnresolved')" @click="gotoFeedBack">
            </el-button>
            <el-button type="primary" icon="el-icon-edit " class="deviceInfoDetailBtn" style="right:20px;" @click="showEditBasicinfoPop" />
          </p>
          <div style="padding: 0px 20px 10px;">
            <div class="deviceInfoDetail" :class="[{'hadHourMeter':basicinfo.hourMeterStatus},{'hadServiceEndTime':basicinfo.serviceEndTime&&$store.state.companyId==4}]">
              <p class="deviceInfoDetailP">SN:{{ basicinfo.deviceSn }}</p>
              <p class="deviceInfoDetailP">{{ basicinfo.mechBrand }}/{{ basicinfo.mechModel }}</p>
              <p class="deviceInfoDetailP">{{ $t('allDeviceDetail.SystemVoltage') }}：{{ basicinfo.batteryVoltage }} V
              </p>
              <p class="deviceInfoDetailP">{{ $t('allDeviceDetail.FirmwareVersiongo') }}：V{{ basicinfo.fwVersion }}</p>
              <p class="deviceInfoDetailP"> {{ $t('allDeviceDetail.BindingTime') }}：{{ createTime }} </p>
              <p class="deviceInfoDetailP">{{ $t('allDeviceDetail.MonitoringDuration') }}：{{ basicinfo.lastUpdateTime }} </p>
              <p v-if="basicinfo.hourMeterStatus" class="deviceInfoDetailP">
                {{ $t('allDeviceDetail.IgnitionTime') }}：{{ basic.IgnitionTimeZh }}({{ basic.IgnitionTime }}{{ $t('dataAndTime.Mins') }})
              </p>
              <p v-if="basicinfo.hourMeterStatus" class="deviceInfoDetailP">
                {{ $t('allDeviceDetail.HourMeTime') }}：{{ basic.hourMeterTimeZh }}({{ basic.hourMeterTime }}{{ $t('dataAndTime.Mins') }})
              </p>
              <p v-if="basicinfo.serviceEndTime&&$store.state.companyId==4" class="deviceInfoDetailP">
                {{ $t('warningInfo.data_until') }}：{{ basicinfo.serviceEndTimeZh }}
              </p>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 锂电池、电池组状态 -->
    <el-row :gutter="40" style="margin-bottom: 32px;">
      <!-- 电池组状态 -->
      <el-col :xs="14" :sm="14" :lg="14" class="card-panel-col">
        <div class="card-panel" style="height: 300px;">
          <p class="blockTitleP">
            <i class="el-icon-time" style="font-size: 24px;" />
            <span style="vertical-align: top;"> {{ timeAgo }}</span>
            <el-button v-if="$store.state.isAdmin || $store.state.companyId=='134'" align="right" style="text-align: center;float:right;margin-right: 10px;" class="filter-item" type="primary" icon="el-icon-download" @click="showDownCanData" />
          </p>
          <div
            style="display: flex;justify-content: space-between;align-items: center;padding: 0 20px;margin-top: 15px;"
            class="batteryStatusTem"
          >
            <div>
              <div style="display: flex;align-items: center;margin: -20px 0 20px;">
                <img v-show="connection!=1" src="@/assets/images/tem.png" alt="" style="margin-right: 10px;height: 50px;">
                <img v-show="connection==1" src="@/assets/images/tem_black.png" alt="" style="margin-right: 10px;height: 50px;">
                <span>{{ temps[0] }}{{ unit }}</span>
              </div>
              <div style="display: flex;align-items: center;">
                <img v-show="connection!=1" src="@/assets/images/tem.png" alt="" style="margin-right: 10px;height: 50px;">
                <img v-show="connection==1" src="@/assets/images/tem_black.png" alt="" style="margin-right: 10px;height: 50px;">
                <span>{{ temps[2] }}{{ unit }}</span>
              </div>
            </div>
            <div style="width: calc(100% - 200px);">
              <div style="padding:10px 0 30px;" class="warningWrap">
                <div v-for="(item,index) in batteryStatusList1" :key="index" class="warningDivs">
                  <img style="width:73px;height:53px;display: inline-block;" :src="item.imgUrl">
                  <p style="margin-top: 5px;">{{ item.value }} V</p>
                </div>
              </div>
              <div style="padding:0 0 30px 0;" class="warningWrap">
                <div v-for="(item,index) in batteryStatusList2" :key="index" class="warningDivs">
                  <img style="width:73px;height:53px;display: inline-block;" :src="item.imgUrl">
                  <p style="margin-top: 5px;">{{ item.value }} V</p>
                </div>
              </div>
            </div>
            <div>
              <div style="display: flex;align-items: center;margin: -20px 0 20px;">
                <img v-show="connection!=1" src="@/assets/images/tem.png" alt="" style="margin-right: 10px;height: 50px;">
                <img v-show="connection==1" src="@/assets/images/tem_black.png" alt="" style="margin-right: 10px;height: 50px;">
                <span>{{ temps[1] }}{{ unit }}</span>
              </div>
              <div style="display: flex;align-items: center;">
                <img v-show="connection!=1" src="@/assets/images/tem.png" alt="" style="margin-right: 10px;height: 50px;">
                <img v-show="connection==1" src="@/assets/images/tem_black.png" alt="" style="margin-right: 10px;height: 50px;">
                <span>{{ temps[3] }}{{ unit }}</span>
              </div>
            </div>
          </div>
        </div>

      </el-col>
      <!-- 锂电池 -->
      <el-col :xs="10" :sm="10" :lg="10" class="card-panel-col">
        <div class="card-panel" style="height:300px;position:relative;">
          
          <el-button type="primary" icon="el-icon-refresh" style="position: absolute;right: 20px;top: 10px;z-index:99;" @click="refresh" />
          <div style="height: calc(100% - 35px)">
            <div class="statusContentWarp">
              <!-- 电池图 -->
              <lithiumBatteryTem :my-device-type="myDeviceType" :battery-status="batteryStatus" :battery-info="batteryInfo" :mcuid="mcuid" :update-time="updateTime" :warning-list="warningList" />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 警告 -->
    <el-row>
      <!-- 继电器状态信息 -->
      <div style="padding: 0 20px 20px;margin-bottom: 32px;background: #fff;">
        <p class="blockTitleP" style="margin-left: -10px;">{{ $t('yhubReport.WarningMessage') }}</p>
        <el-button type="primary" icon="el-icon-edit" class="deviceInfoDetailBtn" style="right: 50px;top: 10px;" @click="goToWarningSettingPage" />
        <!-- <p style="line-height: 40px;font-size: 18px; font-weight: 600;margin-bottom:20px;">警告信息</p> -->
        <!-- 充电中 -->
        <div v-if="liCellWarnings1 != null &&liCellWarnings1.length >= 1" style="padding: 20px 0;border: 1px solid #b2b2b2;display: flex;align-items: center;margin-bottom: 10px;">
          <div style="display: inline-block;vertical-align: top;vertical-align: top;margin:0px 50px 0px 20px;">
            <img src="@/assets/images/cell_state_full_big.png">
          </div>
          <div style="display: inline-block;width: calc(100% - 150px);">
            <div v-for="(item,index) in liCellWarnings1" :key="index" style="position: relative;display: inline-block; margin-right: 50px;font-size: 18px;color: #5c5c5c;">
              <span class="redRadiu" />
              <span style="line-height: 40px;display: inline-block;width: 200px;">{{ item }}</span>
              <!-- <span v-if='item.danger==2' style='width: 16px;height: 16px;background: #7cb329;border-radius:50%;display: inline-block;'></span>
              <span v-if='item.danger==3' style='width: 16px;height: 16px;background: #e6902b;border-radius:50%;display: inline-block;'></span>
              <span v-if='item.danger==4' style='width: 16px;height: 16px;background: #a5a5a5;border-radius:50%;display: inline-block;'></span> -->
            </div>
          </div>
        </div>
        <!-- 放电中 -->
        <div v-if="liCellWarnings2 != null &&liCellWarnings2.length >= 1" style="padding: 20px 0;border: 1px solid #b2b2b2;display: flex;align-items: center;margin-bottom: 10px;">
          <div style="display: inline-block;vertical-align: top;vertical-align: top;margin:0px 50px 0px 20px;">
            <img src="@/assets/images/cell_state_charging_big.png">
          </div>
          <div style="display: inline-block;width: calc(100% - 150px);">
            <div v-for="(item,index) in liCellWarnings2" :key="index" style="position: relative;display: inline-block; margin-right: 50px;font-size: 18px;color: #5c5c5c;">
              <span class="redRadiu" />
              <span style="line-height: 40px;display: inline-block;width: 200px;">{{ item }}</span>
              <!-- <span v-if='item.danger==2' style='width: 16px;height: 16px;background: #7cb329;border-radius:50%;display: inline-block;'></span>
              <span v-if='item.danger==3' style='width: 16px;height: 16px;background: #e6902b;border-radius:50%;display: inline-block;'></span>
              <span v-if='item.danger==4' style='width: 16px;height: 16px;background: #a5a5a5;border-radius:50%;display: inline-block;'></span> -->
            </div>
          </div>
        </div>
        <!-- 加热中 -->
        <div v-if="liCellWarnings3 != null &&liCellWarnings3.length >= 1" style="padding: 20px 0;border: 1px solid #b2b2b2;display: flex;align-items: center;margin-bottom: 10px;">
          <div style="display: inline-block;vertical-align: top;vertical-align: top;margin:0px 50px 0px 20px;">
            <img src="@/assets/images/cell_state_warning_big.png">
          </div>
          <div style="display: inline-block;width: calc(100% - 150px);">
            <div v-for="(item,index) in liCellWarnings3" :key="index" style="position: relative;display: inline-block; margin-right: 50px;font-size: 18px;color: #5c5c5c;">
              <span class="redRadiu" />
              <span style="line-height: 40px;display: inline-block;width: 200px;">{{ item }}</span>
              <!-- <span v-if='item.danger==2' style='width: 16px;height: 16px;background: #7cb329;border-radius:50%;display: inline-block;'></span>
              <span v-if='item.danger==3' style='width: 16px;height: 16px;background: #e6902b;border-radius:50%;display: inline-block;'></span>
              <span v-if='item.danger==4' style='width: 16px;height: 16px;background: #a5a5a5;border-radius:50%;display: inline-block;'></span> -->
            </div>
          </div>
        </div>
      </div>
    </el-row>

    <!-- sim -->
    <!-- <el-row :gutter="40" style="margin-bottom: 32px;">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <div style="padding:0 20px 20px;;background: white;">
          <p class="blockTitleP" style="margin-left: -10px;">SIM</p>
          <simTem :mcu-id="$route.query.mcuId" />
        </div>
      </el-col>
    </el-row> -->

    <div class="p_row clearfix">

      <div class="p_col fl">
        <div class="map_box">
          <el-checkbox v-model="onlyGPS" class="check_box" @change="updateGnssConfig">
            {{ $t('allDeviceDetail.gpsonly') }}</el-checkbox>

          <!-- 高德地图 和 谷歌地图-->
          <!-- <el-container class="right" style="padding-left: 1px;padding-right: 1px;position: relative;background:white;"> -->
          <!--0925 cici-->
          <keep-alive>
            <!-- <g-map ref="maps" style="width: 100%;" :height="height" :have-location-info="haveLocationInfo" :is-show-g-d-map="value1" :is-show-map-float="isShowMapFloat" @fullScreen="fullScreen" /> -->
          </keep-alive>
          <!-- </el-container> -->
        </div>
      </div>
      <!-- 设备日志 -->
      <div class="p_col fl">
        <stepTem :mcu-id="$route.query.mcuId" />
      </div>
    </div>

    <!-- <el-row :gutter="40">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <stepTem :mcu-id="$route.query.mcuId" />
      </el-col>
    </el-row>

    <el-row v-show="isShowMap" :gutter="40" style="margin-bottom: 32px;">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <div style="padding:20px;background: white;">
          <el-checkbox v-model="onlyGPS" style="position: static;padding-top: 5px;" @change="updateGnssConfig()">
            {{ $t('allDeviceDetail.gpsonly') }}</el-checkbox>

          <el-container style="padding-left: 1px;padding-right: 1px;position: relative;background:white;" class="right">

            <keep-alive>
              <g-map ref="maps" :is-show-g-d-map="value1" :have-location-info="haveLocationInfo"
                :is-show-map-float="isShowMapFloat" :height="height" @fullScreen="fullScreen" />
            </keep-alive>
          </el-container>
        </div>
      </el-col>
    </el-row> -->

    <!--编辑基本信息弹窗 -->
    <el-dialog id="editBasicinfoPop" :close-on-click-modal="false" :visible.sync="editBasicinfoPop" width="80%">
      <el-form ref="editBasicinfoPop" :rules="rules" :model="editBasicinfo" label-position="right" label-width="180px" :inline="true">
        <el-row :gutter="40">
          <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.SN')" prop="deviceSn">
              <!--序列号-->
              <el-input v-model="editBasicinfo.deviceSn" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.Machine')" prop="deviceInfo">
              <!--品牌型号(设备信息)-->
              <el-cascader :options="options3" :placeholder="editBasicinfo.mechBrand + '/' + editBasicinfo.mechModel " @change="DeviceModelChange" />
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
            <el-form-item :label="$t('dashboard.DeviceName')" prop="deviceName">
              <!--设备名称-->
              <el-input v-model="editBasicinfo.deviceName" :placeholder="$t('BondOrUpdateDevice.PleaseEnterAName')" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
            <!-- 编辑时，型号和容量不做必填校验 -->
            <el-form-item :label="$t('BondOrUpdateDevice.Model')">
              <!-- 电池型号 -->
              <el-cascader :options="options2" style="width: 200px" :show-all-levels="true" :placeholder="editBasicinfo.batteryBrand + '/' + editBasicinfo.batteryModel" @change="batteryModelChange" />
              <p v-show="isShowBatteryModelWarning" class="redWarningFont">{{ $t('BondOrUpdateDevice.SelectBattery') }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
            <el-form-item :label="$t('basicinfo.SystemVoltage')" prop="batteryVoltage">
              <!--系统电压-->
              <el-input v-model="editBasicinfo.batteryVoltage" :placeholder="$t('BondOrUpdateDevice.PleaseSelectOperatingVoltage')" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.Capacity')">
              <!--容量-->
              <el-input v-model="editBasicinfo.batteryCapacity" :placeholder="$t('BondOrUpdateDevice.EnterBatteryCapacity')" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.OwnedCompany')" prop="company">
              <!--归属公司-->
              <el-select v-model="editBasicinfo.company" :placeholder="editBasicinfo.companyName" class="filter-item" filterable clearable>
                <el-option v-for="(item,index) in companyOptions" :key="index" :label="item.label" :value="item.key" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
            <el-form-item :label="$t('allDeviceDetail.BindingTime')" prop="restTime">
              <!--绑定时间-->
              <el-input v-model="editBasicinfo.resetTime" :disabled="true" />
              <el-button type="primary" icon="el-icon-refresh" class="deviceInfoDetailBtn" @click="showUpdateTimePop" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col cellNumber">
            <el-form-item :label="$t('AllDevices.cellNumber')" prop="cell">
              <el-input v-model="editBasicinfo.cell" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
              <i class="el-icon-question" @mouseover="isShowCellNumPop=true" @mouseout="isShowCellNumPop=false" />
            </el-form-item>
            <div v-if="isShowCellNumPop" class="cellNumberInfoPop">
              <p>{{ $t('allDeviceDetail.cellNumberInfo') }}</p>
            </div>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col cellNumber">
            <el-form-item :label="$t('dashboard.SiteName')">
              <el-autocomplete v-model="editBasicinfo.site" class="inline-input" :fetch-suggestions="querySearchCity" :placeholder="$t('dashboard.SiteName')" @select="handleSelect" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('adminView.battery')+ ' SN'">
              <el-input v-model="editBasicinfo.batterySn" :placeholder="$t('adminView.battery')+ ' SN'" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col fullChargeTime">
            <el-form-item :label="$t('BondOrUpdateDevice.fullChargeTime')" prop="fullChargeTime">
              <el-input v-model="editBasicinfo.fullChargeTime" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
              <span>{{ $t('dataAndTime.Min') }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
            <el-form-item :label="$t('AllDevices.GPS')" prop="batterySystemVolt">
              <el-switch v-model="LocationOrNot" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" />
            </el-form-item>
          </el-col>
          <div v-if="false">
            <el-col :xs="12" :sm="12" :lg="24" class="card-panel-col setting">
              <!--其他设置-->
              <el-form-item :label="$t('BondOrUpdateDevice.Advanced')" label-width="120px" @click.native="isShowSetting=!isShowSetting">
                <p v-show="isShowWarnIcon" style="font-size: 14px;color: red;">「
                  {{ $t('allDeviceDetail.UpdateFailed') }} 」</p>
              </el-form-item>
            </el-col>
            <div v-show="isShowSetting">
              <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.EquipmentType')">
                  <!--设备类型-->
                  <el-checkbox-group v-model="deviceTypeArr">
                    <el-checkbox v-for="(item,index) in deviceTypeOptions" :key="index" :label="item.value" :disabled="item.disabled">{{ item.label }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
                <el-form-item :label="$t('CAN')" prop="canFuntion">
                  <!--CAN类型-->
                  <!-- /<el-input v-model="editBasicinfo.canFuntion" :placeholder="canFuntion" width="120px" @input="change($event)" /> -->
                  <template class="ycdd">
                    <el-select v-model="editBasicinfo.canFuntion" placeholder="请选择" @input="change($event)">
                      <el-option v-for="item in canOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </template>
                </el-form-item>

              </el-col>
              <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.LevelSensor')">
                  <!--液位采集-->
                  <el-radio v-model="editBasicinfo.supportWaterlevel" :label="1" @input="change($event)">
                    {{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
                  <el-radio v-model="editBasicinfo.supportWaterlevel" :label="0" @input="change($event)">
                    {{ $t('BondOrUpdateDevice.No') }}</el-radio>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.LEDIndicator')">
                  <!--面板指示灯-->
                  <el-radio v-model="editBasicinfo.ledSetting" :label="0" @input="change($event)">
                    {{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
                  <el-radio v-model="editBasicinfo.ledSetting" :label="2" @input="change($event)">
                    {{ $t('BondOrUpdateDevice.No') }}</el-radio>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.SensorType')">
                  <!--电流计类型-->
                  <el-radio v-model="editBasicinfo.sensorType" :label="2" @change="sensorTypeChange" @input="change($event)">SHUNT</el-radio>
                  <el-radio v-model="editBasicinfo.sensorType" :label="1" @change="sensorTypeChange" @input="change($event)">HALL</el-radio>
                  <el-radio v-show="isShowHallDetail" v-model="editBasicinfo.hallDirection" :label="0" @change="sensorTypeChange" @input="change($event)">{{ $t('BondOrUpdateDevice.Forward') }}</el-radio>
                  <el-radio v-show="isShowHallDetail" v-model="editBasicinfo.hallDirection" :label="2" @change="sensorTypeChange" @input="change($event)">{{ $t('BondOrUpdateDevice.Reverse') }}</el-radio>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.Track')" prop="extralFuntion" class="ycdd">
                  <!--运动轨迹-->
                  <el-radio v-model="editBasicinfo.extralFuntion" :label="0" @input="change($event)">
                    {{ $t('BondOrUpdateDevice.Off') }}</el-radio>
                  <el-radio v-model="editBasicinfo.extralFuntion" :label="2" @input="change($event)">
                    {{ $t('BondOrUpdateDevice.On') }}</el-radio>
                  <el-input v-show="editBasicinfo.extralFuntion==2" v-model="editBasicinfo.locationSample" type="text" @input="change($event)" />
                  <span v-show="editBasicinfo.extralFuntion==2">{{ $t('BondOrUpdateDevice.SecondsTimes') }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.RemoteControl')">
                  <!--远程断电-->
                  <el-radio v-model="editBasicinfo.supportRelaycontrol" :label="0" @input="change($event)">
                    {{ $t('BondOrUpdateDevice.No') }}</el-radio>
                  <el-radio v-model="editBasicinfo.supportRelaycontrol" :label="1" @input="change($event)">
                    {{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
                  <!-- <el-input v-model="editBasicinfo.locationSample" type="text" />{{ $t('BondOrUpdateDevice.SecondsTimes') }} -->
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
                <el-form-item label="APN">
                  <p>{{ editBasicinfo.gprsApnName }}</p>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
                <el-form-item :label="$t('allDeviceDetail.resetFunction')">
                  <el-button class="filter-item" type="primary" @click="restoreFactorySet">
                    {{ $t('allDeviceDetail.startReset') }}</el-button>
                </el-form-item>
              </el-col>
            </div>
          </div>

          <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
            <el-form-item style="text-align: end;">
              <el-button @click="editBasicinfoPop = false">{{ $t('button.Cancel') }}</el-button>
              <!---->
              <el-button class="filter-item" type="primary" @click="submitBasicinfo('editBasicinfoPop')">
                {{ $t('button.Submit') }}</el-button>
              <!---->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!--恢复出厂设置弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="restoreFactorySetPop" width="60%">
      <el-form ref="restoreFactorySetPop" :rules="rules1" :model="restoreFactorySetInfo" label-position="right" label-width="150px" :inline="true">
        <el-row :gutter="40">
          <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.Passcode')" prop="passcode">
              <el-input v-model="restoreFactorySetInfo.passcode" :placeholder="$t('BondOrUpdateDevice.EnterNumbers')" @blur="blurPasscode" @input="change($event)" />
              <p>{{ findPC }}</p>
              <p v-show="isShowResFacSetInfoPasscode" class="redWarningFont">
                {{ $t('BondOrUpdateDevice.IncorrectPasscode') }}</p>

              <!-- <p v-show="isShowResFacSetInfoPasscode" style="font-size: 14px;color: red;">「 {{ $t('allDeviceDetail.UpdateFailed') }} 」</p> -->
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
            <el-form-item style="text-align: end;">
              <el-button @click="restoreFactorySetPop = false">{{ $t('button.Cancel') }}</el-button>
              <!---->
              <el-button class="filter-item" type="primary" @click="submitRestoreFactorySet('editBasicinfoPop')">
                {{ $t('button.Submit') }}</el-button>
              <!---->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 下载弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="downCanDataPop" width="28%">
      <el-form ref="downCanDataPop" :rules="rules1" :model="restoreFactorySetInfo" label-position="right" label-width="150px" :inline="true">
        <el-row :gutter="40">
          <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
            <el-date-picker v-model="selectDayTable" :end-placeholder="$t('AllDevices.endDate')" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" type="daterange" />
            <el-button align="right" style="text-align: center;float:right;margin-right: 10px;" class="filter-item" type="primary" icon="el-icon-download" @click="downCanData" />
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <maint-tips v-if="dialogVisible" :maint-obj="maintObj" @close="tipsClose" />

    <!-- 数据服务提醒弹窗 -->
    <el-dialog :title="isExpired? $t('warningInfo.has_expired'):$t('warningInfo.renewal_reminder')" :visible.sync="dialogData" width="40%" top="30vh" center>
      <div class="data_dialog_con">
        <p v-if="isExpired">{{ $t('warningInfo.has_expired_desc') }}</p>
        <template v-else>
          <p>{{ $t('warningInfo.renewal_reminder_desc') }}</p>
        </template>
      </div>
    </el-dialog>

  </div>
</template>
<script>

import { getLastBMSRecor, deviceBattery, findDeviceInfo, sysDictInfo, listByCompanyParentId, getGNSSLastByMcuID, getCompanySiteList, getLastRealTimeData, addDeviceBindConfig, updateDeviceBindBase, updateDeviceBind, addDeviceReset, addDeviceAllReset, getLastYhubConfig, getLastOneMsgBMSData, getGnssConfig, updateGnssConfig, getList, cascader, deviceMechcascader, getVehicleMaintenanceMsg, getBatteryMaintenanceMsg, getBatteryLongNoUseMsg, getDataServiceMsg } from '@/api/allDevice'
import { GetRealTimeData } from '@/api/leaseManagement'
// import gMap from '@/components/gmap'// 高德和谷歌地图
import chargedAndDisChart from '@/components/chargedAndDisChart'
import pidEchart from '@/components/pidEchart'
import { getDateAndHour, howLongAgo2, howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'
import vPinyin from '@/utils/pinyin-vue.js'
import lithiumBatteryTem from './components/lithiumBatteryTem'
import simTem from './components/simTem'
import stepTem from './components/stepTem'
import MaintTips from './components/MaintTips.vue'
import yhubPieChart1 from '@/components/yhubPieChart1'
import { temChange, temUnit } from '@/utils/temChange.js'
var checkNumber = (rule, value, callback) => {
  setTimeout(() => {
    if (value && !/^[0-9]*[1-9][0-9]*$/.test(value)) {
      callback(new Error(i18n.t('AllDevices.mustInt')))
    } else {
      callback()
    }
  }, 1000)
}
export default {
  name: 'DashboardAdmin',
  components: {
    // gMap, // 地图
    chargedAndDisChart,
    pidEchart,
    lithiumBatteryTem,
    simTem,
    stepTem,
    yhubPieChart1,
    MaintTips
  },
  data() {
    return {
      unit: '℃',
      isShowMap: true,
      LocationOrNot: false,
      // 地图----start
      height: '440px',
      value1: false, //  是否显示高德地图 true：高德 false：谷歌
      locationList: [], // 地图要描点的集合
      isShowMapFloat: false, // 是否显示图示
      haveLocationInfo: true, // 是否有定位信息
      // 地图----end
      onlyGPS: false,
      basicinfo: {},
      createTime: null,
      pidSeriesData: 0,
      rateHeight: '250px',
      showFirstPie: true,
      pieSeriesData: [{ name: 'Charged', value: 0 }, { name: 'Discharged', value: 0 }],
      isShowSohEchart: true, // soh图表是否显示
      pieSeriesDataName: 'WH',
      pieSeriesData2: [
        { name: 'Charged', value: 0, dw: 'Wh' }, // dw:单位
        { name: 'Discharged', value: 0, dw: 'Wh' }
      ],
      colorArr2: ['#a9d252', '#1e90fc'],
      // 警告
      warningList1: [{ name: '电量低', isColor: 'false', imgUrl: require('@/assets/images/battery_gray.png') },
        { name: '电压低', isColor: 'false', imgUrl: require('@/assets/images/locbatt_gray.png') },
        { name: '液位低', isColor: 'false', imgUrl: require('@/assets/images/water_gray.png') },
        { name: '温度高', isColor: 'false', imgUrl: require('@/assets/images/toohot_gray.png') }
      ],
      warningList2: [{ name: '电量低', isColor: 'false', imgUrl: require('@/assets/images/battery_gray.png') },
        { name: '电压低', isColor: 'false', imgUrl: require('@/assets/images/locbatt_gray.png') },
        { name: '温度高', isColor: 'false', imgUrl: require('@/assets/images/toohot_gray.png') },
        { name: 'SOH差', isColor: 'false', imgUrl: require('@/assets/images/soh_gray.png') },
        { name: '不在设定区域', isColor: 'false', imgUrl: require('@/assets/images/position_gray.png') }
      ],
      isShowWarnIcon: false, // 是否显示感叹号
      editUpdateTimePop: false,
      editUpdateTime: {},
      value2: '',
      batteryInfo: {
        batteryVoltage: null,
        current: null,
        batteryTmp: null,
        soc: null,
        level: null,
        chargingWh: '--',
        usingWh: '--'
      }, // 电池状态--详细信息
      myDeviceType: '0', // 设备类型 1-充电器 4-逆变器 5-锂电池
      batteryStatus: 0, // 电池状态 ['IDLE', 'CHARGING', 'DISCHARGING'], // 静止，充电，放电
      mcuid: this.$route.query.mcuId,
      updateTime: null,
      warningList: [],
      lithiumUpdateTime: null, // 锂电池最后更新时间

      // 编辑设备信息弹窗----start
      editBasicinfoPop: false, // 编辑基本信息弹窗
      editBasicinfo: {
        locationSample: '60',
        batteryVoltage: '24',
        batteryCapacity: null,
        supportWaterlevel: null,
        ledSetting: null,
        sensorType: null,
        hallDirection: null,
        extralFuntion: null,
        supportRelaycontrol: null,
        deviceSn: null,
        mechBrand: null,
        mechModel: null,
        deviceName: null,
        batteryBrand: null,
        batteryModel: null,
        company: null,
        resetTime: null,
        fullChargeTime: '',
        site: ''
      },
      allCity: [],
      rules: {
        deviceName: [{ required: true, message: i18n.t('BondOrUpdateDevice.PleaseEnterAName'), trigger: 'blur' }], // 设备名称不能为空
        deviceSn: [{ required: true, message: i18n.t('BondOrUpdateDevice.SNNotFound'), trigger: 'blur' }], // 序列号不能为空
        mcuId: [{ required: true, message: 'mcuId不能为空', trigger: 'blur' }],
        passcode: [{ required: true, message: i18n.t('BondOrUpdateDevice.IncorrectPasscode'), trigger: 'blur' }], // 激活码不能为空
        batteryCapacity: [{ required: true, message: i18n.t('BondOrUpdateDevice.EnterBatteryCapacity'), trigger: 'blur' }], // 容量不能为空
        batteryVoltage: [{ required: true, message: i18n.t('BondOrUpdateDevice.PleaseSelectOperatingVoltage'), trigger: 'blur' }], // 系统电压不能为空
        cell: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        fullChargeTime: [{ validator: checkNumber, trigger: 'blur' }]
        // owncompany: [{ required: true, message: '归属公司不能为空', trigger: 'change' }]
      },
      rules1: {
        passcode: [{ required: true, message: i18n.t('BondOrUpdateDevice.IncorrectPasscode'), trigger: 'blur' }] // 激活码不能为空
      },
      companyOptions: [], // 编辑设备信息弹窗--归属公司下拉框
      options3: [], // 编辑设备信息弹窗--设备信息（品牌型号）下拉框
      options2: [], // 编辑设备信息弹窗--电池型号下拉框
      deviceTypeOptions: [], // 编辑设备信息弹窗--设备信息多选框
      deviceTypeArr: [], // 选中的设备类型
      isShowHallDetail: false,
      getLastYhubConfig: {},
      isShowSetting: false,
      isShowBatteryModelWarning: false,
      batteryInfoPop: null,
      restoreFactorySetPop: false, // 恢复出厂设置弹窗
      downCanDataPop: false,
      restoreFactorySetInfo: {},
      isShowResFacSetInfoPasscode: false, // 提示不能为空
      canOptions: [
        { value: 0, label: '0 YHUB' },
        { value: 1, label: '1 doogle' },
        { value: 2, label: '2 pgt' },
        { value: 3, label: '3 hsm' },
        { value: 4, label: '4 Kisae' },
        { value: 5, label: '5 BMS' },
        { value: 6, label: '6 GPD' },
        { value: 7, label: '7 hoppecke' },
        { value: 8, label: '8 EVE_BMS' },
        { value: 9, label: '9 SinoboomCAN' },
        { value: 10, label: '10 EVE_F477' },
        { value: 11, label: '11 Yhub_info' }
      ],
      // 编辑基本信息弹窗----end
      findPC: null,
      liCell: {},
      liCellWarnings1: [],
      liCellWarnings2: [],
      liCellWarnings3: [],
      yhubmqtt: {},
      // 八组电池
      batteryStatusList1: [{ value: '--', imgUrl: require('@/assets/images/voltage_offline.png') },
        { value: '--', imgUrl: require('@/assets/images/voltage_offline.png') },
        { value: '--', imgUrl: require('@/assets/images/voltage_offline.png') },
        { value: '--', imgUrl: require('@/assets/images/voltage_offline.png') }],
      batteryStatusList2: [{ value: '--', imgUrl: require('@/assets/images/voltage_offline.png') },
        { value: '--', imgUrl: require('@/assets/images/voltage_offline.png') },
        { value: '--', imgUrl: require('@/assets/images/voltage_offline.png') },
        { value: '--', imgUrl: require('@/assets/images/voltage_offline.png') }],
      temps: ['--', '--', '--', '--'],
      connection: null,
      max: 0,
      min: 0,
      socLow: false, // 电量低
      isIn: false,
      isCharged: false,
      timeAgo: i18n.t('dataAndTime.waitingUpdate'),
      timeAgoRST: '',
      isShowLeft: true,
      oldbatterySystemVolt: '',
      oldbatteryTotalah: '',
      isShowCellNumPop: false,
      selectDayTable: [], // 日期选择
      maintObj: {},
      dialogVisible: false,
      dialogData: false,
      closeCount: 0
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },
    storeYhubmqtt() {
      // console.log('------', this.$store.state.yhubmqtt)
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    // 数据服务已过期
    isExpired() {
      // if (this.dialogData && this.maintObj.triggerValue) {
      const now = new Date().getTime()
      return now >= this.maintObj.triggerValue
      // }
      // return false
    },
    mcuId() {
      return this.$route.query.mcuId
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
      this.MQTT()
      this.timeAgo = ''; this.timeAgo = howLongAgo(this.timeAgoRST)
    },
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.MQTT()
      },
      deep: true
    }
  },
  mounted() {
    this.unit = temUnit()
    if (this.$store.state.map == 'gdMap') { this.value1 = true } else { this.value1 = false } // 地图
    this.queryList()
    this.lithium()
    // this.getRealTimeInfo2()
    this.popInit()
    this.getGnssConfig()
    this.getGNSSLastByMcuID()
    this.refresh()

    // console.log('this.yhubmqtt', this.this.yhubmqtt)
    // console.log('this.yhubmqtt', JSON.parse(sessionStorage.getItem('this.yhubmqtt')))
    // console.log(this.$store)
    setTimeout(() => {
      if (this.$store.state.role == 'guest') return
      this._getVehicleMaintenanceMsg()
    }, 2000)
    this.selectDayTable = [new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000, new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000]
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    fullScreen(height) { // 地图--全屏
      this.height = height
    },
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.timeAgo = howLongAgo(this.timeAgoRST)
        }, 60000)
      }
    },
    _getVehicleMaintenanceMsg() {
      this.closeCount = 0
      getVehicleMaintenanceMsg(this.mcuId).then(res => {
        console.log('车辆维护信息：', res)
        if (res.resultCode == 1001 && res.resultModel) {
          this.dialogVisible = true
          this.maintObj = res.resultModel
        } else {
          this.closeCount = 1
          this._getBatteryMaintenanceMsg()
        }
      })
    },
    _getBatteryMaintenanceMsg() {
      getBatteryMaintenanceMsg(this.mcuId).then(res => {
        console.log('电池维护信息：', res)
        if (res.resultCode == 1001 && res.resultModel) {
          this.dialogVisible = true
          this.maintObj = res.resultModel
        } else {
          this.closeCount = 2
          this._getBatteryLongNoUseMsg()
        }
      })
    },
    _getBatteryLongNoUseMsg() {
      getBatteryLongNoUseMsg(this.mcuId).then(res => {
        console.log('电池长时间未使用信息：', res)
        if (res.resultCode == 1001 && res.resultModel) {
          this.dialogVisible = true
          this.maintObj = res.resultModel
        } else {
          this.closeCount = 3
          this._getDataServiceMsg()
        }
      })
    },
    _getDataServiceMsg() {
      getDataServiceMsg(this.mcuId).then(res => {
        console.log('数据服务提醒：', res)
        if (res.resultCode == 1001 && res.resultModel) {
          this.dialogData = true
          this.maintObj = res.resultModel
        }
      })
    },
    tipsClose() {
      this.dialogVisible = false
      this.dialogData = false
      this.closeCount++
      if (this.closeCount == 1) {
        setTimeout(() => {
          this._getBatteryMaintenanceMsg()
        }, 2000)
      }
      if (this.closeCount == 2) {
        setTimeout(() => {
          this._getBatteryLongNoUseMsg()
        }, 2000)
      }
      if (this.closeCount == 3) {
        setTimeout(() => {
          this._getDataServiceMsg()
        }, 2000)
      }
    },
    refresh() {
      GetRealTimeData({ mcuId: this.$route.query.mcuId }).then(res => { })
    },
    queryList() {
      var param = {
        'mcuId': this.$route.query.mcuId
      }
      if (this.$route.query.deviceType.indexOf('e') > -1) { // 锂电池
        this.isShowSohEchart = false
      } else { this.isShowSohEchart = true }
      // 设备信息
      findDeviceInfo(param).then(res => {
        // console.log(res.resultModel.createTime)
        // 设备信息详情
        this.basicinfo = res.resultModel
        if (this.basicinfo.cell) { this.basicinfo.CellVoltage = (this.basicinfo.batteryVoltage / this.basicinfo.cell).toFixed(2) } else { this.basicinfo.CellVoltage = '--' }
        // this.editBasicinfo = res.resultModel// 编辑设备信息弹窗   basicinfo.batteryCapacity
        if (this.basicinfo.batteryVoltage) this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage > 900 ? (this.basicinfo.batteryVoltage / 100) : this.basicinfo.batteryVoltage
        if (this.basicinfo.batteryCapacity) this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity > 1000 ? (this.basicinfo.batteryCapacity / 100) : this.basicinfo.batteryCapacity
        // else { this.basicinfo.batteryVoltage = '--' }
        // this.batteryInfo = JSON.parse(JSON.stringify(this.basicinfo)) // 电池状态
        if (res.resultModel.resetTime) {
          this.createTime = getDateAndHour(res.resultModel.resetTime, 'noTime')// 绑定时间
          this.basicinfo.lastUpdateTime = howLongAgo2(new Date(res.resultModel.resetTime).getTime())
        }
        this.basicinfo.serviceEndTimeZh = getDateAndHour(res.resultModel.serviceEndTime, 'noTime')
        this.findPC = i18n.t('allDeviceDetail.findPC1') + this.basicinfo.deviceSn + i18n.t('allDeviceDetail.findPC2')
        this.myDeviceType = this.$route.query.deviceType// 电池状态组件--设备类型
        this.editBasicinfo.batterySn = res.resultModel.batterySn
        this.editBasicinfo.site = res.resultModel.site
        this.editBasicinfo.fullChargeTime = res.resultModel.fullChargeTime
        // this.myDeviceType = '0,4'// 电池状态组件--设备类型
        // console.log('deviceType', this.$route.query.deviceType)
        // 编辑基本信息弹窗--获取电池信息
        deviceBattery({ id: this.basicinfo.batteryId }).then(response => {
          this.batteryInfoPop = response.resultModel || {}
        })
        if (res.resultModel.locationStatus == 1) {
          this.LocationOrNot = true
        } else {
          this.LocationOrNot = false
        }
        if (res.resultModel.locationStatus == 1 || this.$store.state.isAdmin) {
          this.isShowMap = true
        } else {
          this.isShowMap = false
        }
      })
    },
    lithium() {
      getLastBMSRecor({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultCode == 1001) {
          if (!res.resultModel) return
          this.batteryInfo.batteryVoltage = res.resultModel.batteryVoltage
          this.batteryInfo.current = res.resultModel.current
          this.batteryInfo.soc = res.resultModel.soc
          // console.log('this.batteryInfo', this.batteryInfo)
          // 电池状态组件--充放电、电池状态['IDLE', 'CHARGING', 'DISCHARGING'], //0 1 2: 静止，充电，放电
          if (res.resultModel.current == 0) { // 静止
            this.batteryStatus = 0
          } else { // 充电、放电 //current:负数表示充电、正数表示放电 *100
            this.batteryStatus = res.resultModel.current < 0 ? 1 : 2
          }
          this.batteryInfo.singleVolTep = res.resultModel.singleVol + '+' + res.resultModel.temperature
          this.pieSeriesData[0].value = Math.round(res.resultModel.chargingAh / 100)// 饼状图数据
          this.pieSeriesData[1].value = Math.round(res.resultModel.usedAh / 100)// 饼状图数据

          this.updateTime = this.lithiumUpdateTime = res.resultModel.yhubTime ? res.resultModel.yhubTime : null
          this.timeAgo = howLongAgo(this.updateTime)
          this.timeAgoRST = this.updateTime
          if (res.resultModel.singleVol) {
            var singleVols = JSON.parse(res.resultModel.singleVol)
            var arr1 = singleVols.slice(0, 4)
            var arr2 = singleVols.slice(4, 8)
            arr1.forEach((v, i) => {
              this.batteryStatusList1[i].value = arr1[i] / 1000
            })
            arr2.forEach((v, i) => {
              this.batteryStatusList2[i].value = arr2[i] / 1000
            })
            this.max = Math.max(...singleVols) / 1000
            this.min = Math.min(...singleVols) / 1000
            this.batteryStatusList1.forEach((v, i) => {
              this.batteryStatusList1[i].imgUrl = require('@/assets/images/voltage_online.png')
              if (v.value == this.max && this.max !== this.min) this.batteryStatusList1[i].imgUrl = require('@/assets/images/highvoltage.png')
              if (v.value == this.min && this.max !== this.min) this.batteryStatusList1[i].imgUrl = require('@/assets/images/lowvoltage.png')
            })
            this.batteryStatusList2.forEach((v, i) => {
              this.batteryStatusList2[i].imgUrl = require('@/assets/images/voltage_online.png')
              if (v.value == this.max && this.max !== this.min) this.batteryStatusList2[i].imgUrl = require('@/assets/images/highvoltage.png')
              if (v.value == this.min && this.max !== this.min) this.batteryStatusList2[i].imgUrl = require('@/assets/images/lowvoltage.png')
            })
          }
          if (res.resultModel.temperature) {
            this.connection = 1
            this.temps = JSON.parse(res.resultModel.temperature)
            // console.log(this.temps)
            this.temps.forEach((v, i) => {
              if (v && v != '--') this.temps[i] = temChange(v)
              // console.log(v)
              // console.log(this.temps)
            })
            // console.log(temps)

            // this.temps[1] = JSON.parse(res.resultModel.temperature)[1]
          }
        }
      })
      getLastRealTimeData({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultCode == 1001) {
          if (!res.resultModel) return
          var chargingWh = res.resultModel.chargingWh ? (res.resultModel.chargingWh / 100).toFixed(2) : 0 // 饼状图数据
          var usingWh = res.resultModel.usingWh ? (res.resultModel.usingWh / 100).toFixed(2) : 0 // 饼状图数据
          if (chargingWh <= 1000 && usingWh <= 1000) {
            this.pieSeriesDataName = 'WH'
            this.pieSeriesData2[0].value = chargingWh// 饼状图数据
            this.pieSeriesData2[1].value = usingWh// 饼状图数据
            this.pieSeriesData2[0].dw = this.pieSeriesData2[0].dw = 'Wh'
          } else {
            this.pieSeriesDataName = 'KWH'
            this.pieSeriesData2[0].value = chargingWh ? (chargingWh / 1000).toFixed(2) : 0 // 饼状图数据
            this.pieSeriesData2[1].value = usingWh ? (usingWh / 1000).toFixed(2) : 0 // 饼状图数据
            this.pieSeriesData2[0].dw = this.pieSeriesData2[0].dw = 'kWh'
          }
          // this.batteryInfo.chargingWh = res.resultModel.chargingWh
          // this.batteryInfo.usingWh = res.resultModel.usingWh
        }
      })
    },
    // 饼状图切换
    changePieChart(event, val, index) {
      // 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
        console.log('triggerResize--', triggerResize)
      }, 0)

      var eventParent = event.target.nodeName == 'SPAN' ? event.target.parentElement.parentElement : event.target.parentElement
      var eventDiv = document.getElementsByClassName('pieChartDiv')[index]
      if (val == 1) {
        eventDiv.firstChild.style.display = 'block'
        eventDiv.lastChild.style.display = 'none'
        eventParent.firstChild.classList.add('active')
        this.showFirstPie = true
        // eventParent.lastChild.classList.remove('active')
        eventParent.querySelector('.changePieBtn:nth-child(2)').classList.remove('active')
      } else if (val == 2) {
        eventDiv.firstChild.style.display = 'none'
        eventDiv.lastChild.style.display = 'block'
        eventParent.firstChild.classList.remove('active')
        this.showFirstPie = false
        // eventParent.lastChild.classList.add('active')
        eventParent.querySelector('.changePieBtn:nth-child(2)').classList.add('active')
      }
    },
    // getRealTimeInfo2() {
    //   getRealTimeInfo2({ sn: this.$route.query.sn }).then(res => {
    //     // this.warningList = []
    //     // res.data.warning.forEach(v => {
    //     //   this.warningList.push(v.msgType)
    //     // })
    //     // this.warningList = [1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
    //     // if (!res.data) return
    //     // var locationList = []
    //     // locationList.push({
    //     //   deviceName: this.basicinfo.deviceName,
    //     //   mcuId: this.$route.query.mcuId,
    //     //   lType: res.data.gpsType,
    //     //   lat: res.data.latitude,
    //     //   lon: res.data.longitude,
    //     //   updataTime: res.data.t,
    //     //   status: null
    //     // })
    //     // var center = {
    //     //   lat: res.data.latitude,
    //     //   lon: res.data.longitude,
    //     //   radius: '100'
    //     // }
    //     // setTimeout(() => {
    //     //   this.$refs.maps.setMakers(locationList)
    //     //   this.$refs.maps.setCenter(center)
    //     // }, 500)
    //   })
    // },
    getGnssConfig() {
      getGnssConfig({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultCode === 1001) {
          if (res.resultModel === 1) { this.onlyGPS = true }
        }
      })
    },
    updateGnssConfig() {
      // debugger
      var isOnlyGPS = 0
      if (this.onlyGPS) {
        isOnlyGPS = 1
      }
      if (this.onlyGPS !== 'undefined') {
        updateGnssConfig({ 'mcuId': this.$route.query.mcuId, 'gpsOnly': isOnlyGPS, 'updateById': 11 }).then(response => {
          // this.getRealTimeInfo2()
          this.getGNSSLastByMcuID()
        })
      }
    },
    getGNSSLastByMcuID() {
      getGNSSLastByMcuID({ 'mcuId': this.$route.query.mcuId }).then(res => {
        if (res.resultCode == 1001) {
          if (!res.resultModel) {
            res.resultModel = {
              lType: '',
              lat: '',
              lon: '',
              updataTime: ''
            }
          }
          if (!res.resultModel.lat || !res.resultModel.lon) { this.haveLocationInfo = false } else { this.haveLocationInfo = true }
          var locationList = []
          locationList.push({
            deviceName: this.basicinfo.deviceName,
            mcuId: this.$route.query.mcuId,
            lType: res.resultModel.lType,
            lat: res.resultModel.lat,
            lon: res.resultModel.lon,
            updataTime: res.resultModel.updataTime,
            status: null
          })
          var center = {
            lat: res.resultModel.lat,
            lon: res.resultModel.lon,
            radius: '100'
          }
          setTimeout(() => {
            this.$refs.maps.setMakers(locationList)
            // this.$refs.maps.setCenter(center)
          }, 500)
        }
      })
    },
    popInit() { // 编辑基本信息弹窗--初始化
      // 编辑设备信息弹窗--设备类型多选框
      sysDictInfo().then(res => {
        res.resultModel.forEach(v => {
          this.deviceTypeOptions.push({
            label: v.name,
            value: v.k,
            disabled: false
          })
        })
      })
      // 编辑设备信息弹窗--归属公司下拉框

      listByCompanyParentId({ companyParentId: this.$store.state.company.id }).then(response => {
        if (response.resultCode == 1001) {
          this.companyOptions = []
          if (response.resultModel && response.resultModel.length > 1) { this.haveChildCompany = true } else { this.haveChildCompany = false }
          response.resultModel.forEach(v => {
            if (v.companyName) this.companyOptions.push({ label: v.companyName, key: v.id })
          })
          this.companyOptionsFun()
        }
      })
      // 编辑基本信息弹窗--品牌型号下拉框
      deviceMechcascader().then(response => {
        this.options3 = response.resultModel
      })
      // 编辑基本信息弹窗--电池型号下拉框
      cascader().then(response => {
        this.options2 = response.resultModel
      })
    },
    getCity() { // 获取已有的地址
      this.allCity = []
      getCompanySiteList().then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.forEach(v => {
          this.allCity.push({ value: v })
        })
      })
    },
    querySearchCity(queryString, cb) {
      var allCity = this.allCity
      var results = queryString ? allCity.filter(this.createFilter(queryString)) : allCity
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    handleSelect(item) {
    },
    companyOptionsFun() {
      var sessionCompany = JSON.parse(sessionStorage.getItem('companyInfo'))
      // 将归属公司转拼音进行排序
      this.companyOptions.forEach(v => {
        if ((v.label)[0] >= 'a' && (v.label)[0] <= 'z') {
          v.namePinyin = vPinyin.chineseToPinYin(v.label.toUpperCase())
        } else {
          v.namePinyin = vPinyin.chineseToPinYin(v.label)
        }
      })
      this.companyOptions.sort(arrObjSort('namePinyin'))
      var hadSelfCompany = false // 是否包含自己所在公司。因为受域名限制，可能不展示自己所在公司
      // 排序后，自己公司可能不在首位，所以先删除，再添加
      this.companyOptions.forEach((v, i) => {
        if (v.key == sessionCompany.id) {
          hadSelfCompany = true
          this.companyOptions.splice(i, 1)
        }
      })
      if (hadSelfCompany) {
        this.companyOptions.unshift({
          label: sessionCompany.companyName,
          key: sessionCompany.id
        })
      }
    },
    gotoFeedBack() { // 去问题反馈页
      var routeData = this.$router.resolve({
        path: '/feedBack/feedBackIndex',
        query: {
          sn: this.$route.query.sn
        }
      })
      window.open(routeData.href, '_self')
    },
    showEditBasicinfoPop() { // 编辑基本信息弹窗--显示
      this.getCity()
      getLastYhubConfig({ mcuId: this.$route.query.mcuId }).then(res => {
        // getLastYhubConfig({ mcuId: '000800154d4d430b20343538' }).then(res => {
        // this.editBasicinfo = res.resultModel || {}// 编辑设备信息弹窗
        this.editBasicinfo.deviceType = this.basicinfo.deviceType
        this.editBasicinfo.deviceSn = this.basicinfo.deviceSn
        this.editBasicinfo.mechBrand = this.basicinfo.mechBrand
        this.editBasicinfo.mechModel = this.basicinfo.mechModel
        this.editBasicinfo.mechId = this.basicinfo.mechId
        this.editBasicinfo.deviceName = this.basicinfo.deviceName
        this.editBasicinfo.company = this.basicinfo.companyId
        this.editBasicinfo.resetTime = this.basicinfo.createTime
        this.editBasicinfo.cell = this.basicinfo.cell
        // this.editBasicinfo.batteryVoltage = this.editBasicinfo.batterySystemVolt ? this.editBasicinfo.batterySystemVolt : '24'
        // deviceBattery({ id: this.basicinfo.batteryId }).then(response => {
        // debugger
        var hadThisCompany = this.companyOptions.some(v => { return v.key == this.basicinfo.companyId })
        // 当公司id不在this.companyOptions中，即公司为所在公司的子公司的子公司，且登录用户无admin权限
        if (!hadThisCompany) {
          this.editBasicinfo.companyId = this.basicinfo.companyId
          this.editBasicinfo.company = this.basicinfo.companyName
        }
        if (this.batteryInfoPop) {
          this.editBasicinfo.batteryId = this.batteryInfoPop.id
          this.editBasicinfo.batteryModel = this.batteryInfoPop.batteryModel
          this.editBasicinfo.batteryBrand = this.batteryInfoPop.batteryBrand
          this.editBasicinfo.batteryCapacity = this.batteryInfoPop.batteryAh
        }
        // })
        // this.editBasicinfo.deviceSn=this.basicinfo.deviceSn
        this.getLastYhubConfig = res.resultModel || {}
        if (res.resultModel && (res.resultModel.status == 1 || res.resultModel.status == 3)) { this.isShowWarnIcon = true } else { this.isShowWarnIcon = false }
        this.editBasicinfoPop = true
        this.editBasicinfo.locationSample = this.getLastYhubConfig.locationSample ? this.getLastYhubConfig.locationSample : '60'
        this.editBasicinfo.canFuntion = this.getLastYhubConfig.canFuntion ? this.getLastYhubConfig.canFuntion : 0
        this.editBasicinfo.supportWaterlevel = this.getLastYhubConfig.supportWaterlevel ? this.getLastYhubConfig.supportWaterlevel : 0
        this.editBasicinfo.ledSetting = this.getLastYhubConfig.ledSetting ? this.getLastYhubConfig.ledSetting : 0
        this.editBasicinfo.sensorType = this.getLastYhubConfig.sensorType ? this.getLastYhubConfig.sensorType : 1
        this.editBasicinfo.hallDirection = this.getLastYhubConfig.hallDirection ? this.getLastYhubConfig.hallDirection : 0
        this.editBasicinfo.extralFuntion = this.getLastYhubConfig.extralFuntion ? this.getLastYhubConfig.extralFuntion : 0
        this.editBasicinfo.supportRelaycontrol = this.getLastYhubConfig.supportRelaycontrol ? this.getLastYhubConfig.supportRelaycontrol : 0
        this.editBasicinfo.gprsApnName = this.getLastYhubConfig.gprsApnName ? this.getLastYhubConfig.gprsApnName : this.editBasicinfo.gprsApnName = '263.cs101'
        this.oldbatterySystemVolt = this.getLastYhubConfig.batterySystemVolt ? this.getLastYhubConfig.batterySystemVolt : 24
        this.oldbatteryTotalah = this.getLastYhubConfig.batteryTotalah ? (this.getLastYhubConfig.batteryTotalah / 100) : this.editBasicinfo.batteryCapacity * 100

        if (this.editBasicinfo.deviceType.indexOf(',') > -1) {
          this.deviceTypeArr = []
          this.editBasicinfo.deviceType.split(',').forEach(v => {
            this.deviceTypeArr.push(v)
          })
        } else {
          this.deviceTypeArr[0] = this.editBasicinfo.deviceType
        }
        // const ListForm = Object.assign({}, this.editBasicinfo, this.getLastYhubConfig)// 合并对象
        // this.editBasicinfo = ListForm
        // for (var i in this.editBasicinfo) {
        //   for (var j in this.basicinfo) {
        //     if (i == j) this.editBasicinfo[i] = this.basicinfo[j]
        //   }
        // }
        console.log('editBasicinfo===========', this.editBasicinfo)
        // console.log('getLastYhubConfig', this.getLastYhubConfig)
        this.editBasicinfo.resetTime = this.createTime
        if (this.editBasicinfo.sensorType == 1 || this.editBasicinfo.sensorType == '1') this.isShowHallDetail = true
        if (this.getLastYhubConfig.batterySystemVolt) { this.editBasicinfo.batteryVoltage = this.getLastYhubConfig.batterySystemVolt > 900 ? (this.getLastYhubConfig.batterySystemVolt / 100) : this.getLastYhubConfig.batterySystemVolt } else { this.editBasicinfo.batteryVoltage = '24' }
        if (this.getLastYhubConfig.batteryTotalah) { this.editBasicinfo.batteryCapacity = this.getLastYhubConfig.batteryTotalah > 1000 ? Math.round(this.getLastYhubConfig.batteryTotalah / 100) : this.getLastYhubConfig.batteryTotalah } else { this.editBasicinfo.batteryCapacity = '225' }
      })

      // console.log('editBasicinfo', this.editBasicinfo)
    },
    batteryModelChange(value) { // 添加设备--电池型号选中
      this.editBasicinfo.batteryCapacity = value[1].batteryAh
      this.editBasicinfo.batteryId = value[1].id
      this.editBasicinfo.batteryModel = value[1].batteryModel
      this.isShowBatteryModelWarning = false
      // console.log(value[1].batteryModel)
      // console.log(typeof value[1].batteryModel)
    },
    change(e) {
      this.$forceUpdate()
    },
    mouseoverQuestion(index) {
      document.querySelectorAll('.questionPop')[index].style.display = 'block'
    },
    mouseoutQuestion(index) {
      document.querySelectorAll('.questionPop')[index].style.display = 'none'
    },
    sensorTypeChange() { // 编辑基本信息弹窗--电流计类型选中
      switch (this.editBasicinfo.sensorType) {
        case '1': this.isShowHallDetail = true; break
        case 1: this.isShowHallDetail = true; break
        default: this.isShowHallDetail = false; break
      }
    },
    DeviceModelChange(value) { // 编辑基本信息弹窗--品牌型号选中
      this.editBasicinfo.mechId = value[2].id
      this.editBasicinfo.mechBrand = value[2].mechBrand
      this.editBasicinfo.mechModel = value[2].mechModel
      this.editBasicinfo.mechType = value[2].mechType
    },
    submitBasicinfo(formName) { // 编辑基本信息弹窗--提交
      var param = {
        id: this.basicinfo.id,
        mechId: this.editBasicinfo.mechId,
        mcuId: this.$route.query.mcuId,
        companyName: this.editBasicinfo.companyName,
        companyId: this.editBasicinfo.company,
        deviceName: this.editBasicinfo.deviceName,
        deviceSn: this.editBasicinfo.deviceSn,
        batteryModel: this.editBasicinfo.batteryModel,
        // yhubConfig: this.getLastYhubConfig
        locationStatus: '',
        batterySn: this.editBasicinfo.batterySn,
        cell: this.editBasicinfo.cell,
        site: this.editBasicinfo.site,
        fullChargeTime: this.editBasicinfo.fullChargeTime
      }
      if (!this.LocationOrNot) {
        param.locationStatus = 0
      } else {
        param.locationStatus = 1
      }
      var hadThisCompanyId = this.companyOptions.some(v => { return this.editBasicinfo.company == v.key })
      // 当公司this.editBasicinfo.company不在this.companyOptions中，即公司为所在公司的子公司的子公司，且登录用户无admin权限
      if (!hadThisCompanyId) {
        param.companyId = this.basicinfo.companyId
      }
      var yhubConfig = { // 赋默认值
        'batteryId': 1,
        'batterySystemVolt': 24,
        'batteryTotalah': 22500,
        'canFuntion': '0',
        'configFrom': 201,
        'configVersion': 234,
        'extralFuntion': 0,
        'gprsApnName': '263.cs101',
        'hallDirection': 0,
        'hallSensorRange': 0,
        'ledSetting': 0,
        'locationSample': 60,
        'sensorType': 1,
        'supportRelaycontrol': 0,
        'supportWaterlevel': 0,
        mcuId: this.$route.query.mcuId
      }
      for (var i in yhubConfig) { // 若getLastYhubConfig存在，则替代
        for (var j in this.getLastYhubConfig) {
          if (i == j) yhubConfig[i] = this.getLastYhubConfig[j]
        }
      }

      for (var i in yhubConfig) {
        for (var j in this.editBasicinfo) {
          if (i == j) yhubConfig[i] = this.editBasicinfo[j]
        }
      }
      // if (this.deviceTypeArr.length == 1) {
      //   param.deviceType = this.deviceTypeArr[0]
      // } else if (this.deviceTypeArr.length > 1) {
      //   param.deviceType = this.deviceTypeArr.join(',')
      // }
      yhubConfig.gprsApnName = this.editBasicinfo.gprsApnName
      if (this.editBasicinfo.extralFuntion) yhubConfig.extralFuntion = this.editBasicinfo.extralFuntion
      if (this.editBasicinfo.supportRelaycontrol) yhubConfig.supportRelaycontrol = this.editBasicinfo.supportRelaycontrol
      if (this.editBasicinfo.batteryVoltage) { yhubConfig.batterySystemVolt = parseFloat(this.editBasicinfo.batteryVoltage) }
      if (this.editBasicinfo.batteryCapacity) yhubConfig.batteryTotalah = parseFloat(this.editBasicinfo.batteryCapacity) * 100
      // console.log(param)
      // if (!this.editBasicinfo.batteryId) {
      //   this.isShowBatteryModelWarning = true
      //   // this.$message.error('请选择型号')
      //   return
      // }

      // console.log(param)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateDeviceBindBase(param).then(response => {
            if (response.resultCode === 1001) {
              this.$message({
                type: 'success',
                message: 'Succeed!'
              })
              this.editBasicinfoPop = false
              this.queryList()
              if (this.oldbatterySystemVolt != this.editBasicinfo.batterySystemVolt || this.oldbatteryTotalah != this.editBasicinfo.batteryTotalah) {
                yhubConfig.batterySystemVolt = this.editBasicinfo.batteryVoltage
                yhubConfig.batteryTotalah = this.editBasicinfo.batteryCapacity * 100
                addDeviceBindConfig(yhubConfig).then(response => { })
              }
            } else {
              this.$message({
                type: 'error',
                message: response.resultMessage
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    showUpdateTimePop() { // 编辑重置时间弹窗--显示
      // this.editUpdateTimePop = true
      this.editUpdateTime.createTime = this.createTime
      this.editUpdateTime.updateTime = getDateAndHour(new Date().getTime(), 'noTime')
      this.$alert(i18n.t('BondOrUpdateDevice.ResetBindingTime'), '', {
        confirmButtonText: i18n.t('button.Confirm'),
        callback: action => {
          if (action == 'confirm') {
            this.submitUpdateTime()
          }
        }
      })
    },
    submitUpdateTime(formName) { // 编辑重置时间弹窗--提交
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      addDeviceReset({ mcuId: this.$route.query.mcuId }).then(response => {
        if (response.resultCode === 1001) {
          this.$message({
            type: 'success',
            message: 'Succeed!'
          })
          this.editUpdateTimePop = false
        }
        this.createTime = getDateAndHour(new Date().getTime(), 'noTime')
        this.editBasicinfo.resetTime = getDateAndHour(new Date().getTime(), 'noTime')
        this.basicinfo.lastUpdateTime = howLongAgo2(new Date().getTime())
        // this.queryList()
      })
      // } else {
      //   console.log('error submit!!')
      //   return false
      // }
      // })
    },
    restoreFactorySet() { // 恢复出厂设置
      this.restoreFactorySetPop = true
    },
    showDownCanData() {
      this.downCanDataPop = true
    },
    downCanData() {
      if (this.selectDayTable == null) {
        this.$message({
          type: 'error',
          message: i18n.t('AllDevices.downCanDataCheckDate')
        })
        return
      }
      var startDate = new Date(this.selectDayTable[0]).setHours(0, 0, 0, 0)
      var endDate = new Date(this.selectDayTable[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
      if (isNaN(startDate) || isNaN(endDate)) {
        this.$message({
          type: 'error',
          message: i18n.t('AllDevices.downCanDataCheckDate')
        })
        return
      }
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportCanData?sn=' + this.basicinfo.deviceSn + '&mcuId=' + this.basicinfo.mcuId + '&startDate=' + startDate + '&endDate=' + endDate + '&showAll=false'
      window.open(url, '_bank')
    },
    blurPasscode() {
      if (this.restoreFactorySetInfo.passcode) {
        this.isShowResFacSetInfoPasscode = false
      } else {
        this.isShowResFacSetInfoPasscode = true
      }
    },
    submitRestoreFactorySet() {
      if (!this.restoreFactorySetInfo.passcode) {
        this.isShowResFacSetInfoPasscode = true
        return
      }
      this.$confirm(i18n.t('allDeviceDetail.confirmReset'), '', {// '是否恢复出厂设置?'
        confirmButtonText: i18n.t('button.Confirm'), // '确定',
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        var param = {
          // 'mcuId': '05d6ff393430475043165127',
          // 'pc': 518386
          'mcuId': this.$route.query.mcuId,
          'pc': this.restoreFactorySetInfo.passcode
        }
        // console.log(param)
        addDeviceAllReset(param).then(res => {
          if (res.resultCode == 1001) {
            this.restoreFactorySetPop = false
            this.$message({
              type: 'success',
              message: i18n.t('allDeviceDetail.resetSucceed')// '重置成功!'
            })
          } else {
            this.$message({
              type: 'error',
              message: i18n.t('allDeviceDetail.resetFailed')// '重置失败!'
            })
          }
        })
      }).catch(() => { })
    },
    goToReport() {
      var routeData
      if (this.$route.query.deviceType.indexOf('e') == -1) { // 非锂电池
        routeData = this.$router.resolve({
          path: '/allDevices/yhubReport',
          query: {
            mcuId: this.$route.query.mcuId,
            latest: this.updateTime
            // mcuId: '05d9ff333432554e43133650'
          }
        })
        window.open(routeData.href, '_self')
      } else {
        var endtime = this.lithiumUpdateTime ? Date.parse(new Date(this.lithiumUpdateTime)) : Date.parse(new Date())
        routeData = this.$router.resolve({
          path: '/allDevices/lithiumChartPage',
          query: {
            mcuId: this.$route.query.mcuId,
            deviceName: this.basicinfo.deviceName,
            startTime: endtime - 1000 * 60 * 60 * 24,
            endTime: endtime,
            sn: this.basicinfo.deviceSn
            // deviceName: 'Lithium 6673',
            // endTime: 1577409840000,
            // mcuId: '05d8ff333332534e43214127',
            // startTime: 1577323440000
          }
        })
        window.open(routeData.href, '_self')
      }
    },
    goToWarningSettingPage() {
      var routeData = this.$router.resolve({
        path: '/warning/warningSet',
        query: {
          mcuId: this.$route.query.mcuId
          // mcuId: '05d9ff333432554e43133650'
        }
      })
      window.open(routeData.href, '_self')
    },
    getWarning(sys_Status1Int, sys_Status2Int, sys_Status3Int) {
      this.liCellWarnings1 = []
      this.liCellWarnings2 = []
      this.liCellWarnings3 = []
      // var sys_Status1Int = 3 // 充电
      if (sys_Status1Int !== 0) {
        // console.log('警告数据==>' + sys_Status1Int)
        if (this.getBit(sys_Status1Int, 0)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ChargingOvervoltage'))// '充电单体过压'
        }
        if (this.getBit(sys_Status1Int, 1)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ChargingTotalVoltageOver'))// '充电总压过压'
        }
        if (this.getBit(sys_Status1Int, 2)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ChargingTemTooHigh'))// '充电温度过高'
        }
        if (this.getBit(sys_Status1Int, 3)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ChargingTemTooLow'))// '充电温度过低'
        }
        if (this.getBit(sys_Status1Int, 4)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ChargeOvercurrent'))// '充电过流'
        }
        if (this.getBit(sys_Status1Int, 5)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ChargerMalfunction'))// '充电机故障'
        }
        if (this.getBit(sys_Status1Int, 6)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.InsulationTooLow'))// '绝缘过低'
        }
        if (this.getBit(sys_Status1Int, 7)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ComInterrupted'))// '通信中断'
        }
      }
      // var sys_Status2Int = this.yhubmqtt.mErrorCode.mBMSData.BMS2CarFrame1.sys_Status2 // 放电
      // var sys_Status2Int = 3 // 放电
      if (sys_Status2Int !== 0) {
        // console.log('警告数据==>' + sys_Status2Int)
        if (this.getBit(sys_Status2Int, 0)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.DischargeMonUnder'))// '放电单体欠压'
        }
        if (this.getBit(sys_Status2Int, 1)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.TotalDisVLow'))// '放电总压过低'
        }
        if (this.getBit(sys_Status2Int, 2)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.DischargeTemHigh'))// '放电温度过高'
        }
        if (this.getBit(sys_Status2Int, 3)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.DischargeTemLow'))// '放电温度过低'
        }
        if (this.getBit(sys_Status2Int, 4)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.DischargeOvercurrent'))// '放电过流'
        }
        if (this.getBit(sys_Status2Int, 5)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.ExcessiveDifference'))// '压差过大'
        }
        if (this.getBit(sys_Status2Int, 6)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.TemperatureLarge'))// '温差过大'
        }
        if (this.getBit(sys_Status2Int, 7)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.DangerVoltageProtect'))// '危险电压保护'
        }
      }
      // var sys_Status3Int = this.yhubmqtt.mErrorCode.mBMSData.BMS2CarFrame1.sys_Status3 // 橙色警告
      // var sys_Status3Int = 2 // 橙色警告
      if (sys_Status3Int !== 0) {
        // console.log('警告数据==>' + sys_Status3Int)
        if (this.getBit(sys_Status3Int, 0)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.LowSOC'))// 'SOC低'
        }
        if (this.getBit(sys_Status3Int, 1)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.DischargeToalOverv'))// '放电总电压过压'
        }
        if (this.getBit(sys_Status3Int, 2)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ChargingTotalUnderV'))// '充电总电压欠压'
        }
        if (this.getBit(sys_Status3Int, 3)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.DischargeCellOverV'))// '放电单体过压'
        }
        if (this.getBit(sys_Status3Int, 4)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ChargingUndervoltage'))// '充电单体欠压'
        }
        if (this.getBit(sys_Status3Int, 5)) {
          this.liCellWarnings1.push(i18n.t('lithiumWarn.ChargingTemLow'))// '充电温度过低'
        }
        if (this.getBit(sys_Status3Int, 6)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.ChargingTemTooHigh'))// '放电温度过高'
        }
        if (this.getBit(sys_Status3Int, 7)) {
          this.liCellWarnings2.push(i18n.t('lithiumWarn.RelayAdhesion'))// '继电器粘连'
        }
      }
    },
    MQTT() {
      if (this.yhubmqtt) {
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        // console.log('MQTT=======', this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        // console.log(this.myDeviceType)
        // mErrorCode.mUploadBMSRecordReq.batteryVoltage mErrorCode.payload mErrorCode.mBMSData.BMS2CarFrame1
        // console.log('MQTT=======', this.yhubmqtt)
        if (this.yhubmqtt.payload === 'mErrorCode') {
          if (this.yhubmqtt.mErrorCode.payload === 'mBMSData') {
            console.log('mErrorCode=======', this.yhubmqtt.mErrorCode.mBMSData)

            if (this.yhubmqtt.mErrorCode.mBMSData.BMS2CarFrame1 != null) {
              var sys_Status1Int = this.yhubmqtt.mErrorCode.mBMSData.BMS2CarFrame1.sys_Status1 // 充电
              var sys_Status2Int = this.yhubmqtt.mErrorCode.mBMSData.BMS2CarFrame1.sys_Status2 // 放电
              var sys_Status3Int = this.yhubmqtt.mErrorCode.mBMSData.BMS2CarFrame1.sys_Status3 // 橙色警告
              this.getWarning(sys_Status1Int, sys_Status2Int, sys_Status3Int)
            }
          }
        }
        if (this.yhubmqtt.payload === 'mRealTimeData') {
          if (this.yhubmqtt && this.yhubmqtt.mRealTimeData && this.yhubmqtt.mRealTimeData.dRecord) {
            var dRecord = {}
            dRecord = this.yhubmqtt.mRealTimeData.bmsRecord
            console.log('mRealTimeData---', dRecord)
            if (dRecord) {
              if (dRecord.batteryVoltage == 0 || !dRecord.batteryVoltage) { return }
              this.timeAgo = i18n.t('dataAndTime.AMomentAgo')
              this.timeAgoRST = new Date().getTime()
              // 八组电池
              var batterys = dRecord.singleVol || []
              // var batterys = [3300, 3100, 3300, 3400, 3300, 3500, 3300, 3100]
              var arr1 = batterys.slice(0, 4)
              var arr2 = batterys.slice(4, 8)
              arr1.forEach((v, i) => {
                this.batteryStatusList1[i].value = arr1[i] / 1000
              })
              arr2.forEach((v, i) => {
                this.batteryStatusList2[i].value = arr2[i] / 1000
              })
              if (dRecord.temperature) {
                this.connection = 1
                this.temps = dRecord.temperature
                this.temps.forEach((v, i) => {
                  if (v && v != '--') this.temps[i] = temChange(v)
                })
                // this.temps[1] = dRecord.temperature[1]
              }
              this.max = Math.max(...batterys) / 1000
              this.min = Math.min(...batterys) / 1000
              this.batteryStatusList1.forEach((v, i) => {
                this.batteryStatusList1[i].imgUrl = require('@/assets/images/voltage_online.png')
                if (v.value == this.max && this.max !== this.min) this.batteryStatusList1[i].imgUrl = require('@/assets/images/highvoltage.png')
                if (v.value == this.min && this.max !== this.min) this.batteryStatusList1[i].imgUrl = require('@/assets/images/lowvoltage.png')
              })
              this.batteryStatusList2.forEach((v, i) => {
                this.batteryStatusList2[i].imgUrl = require('@/assets/images/voltage_online.png')
                if (v.value == this.max && this.max !== this.min) this.batteryStatusList2[i].imgUrl = require('@/assets/images/highvoltage.png')
                if (v.value == this.min && this.max !== this.min) this.batteryStatusList2[i].imgUrl = require('@/assets/images/lowvoltage.png')
              })
              var sys_Status1 = dRecord.sys_Status1 // 充电
              var sys_Status2 = dRecord.sys_Status2 // 放电
              var sys_Status3 = dRecord.sys_Status3 // 橙色警告
              this.getWarning(sys_Status1, sys_Status2, sys_Status3)
              // this.battery = obj
            }
          }
        }
      }
    },
    // uuid随机生成   MQTT
    getuuid() {
      var uid = []
      var hexDigits = '0123456789abcdefghijklmnopqrst'
      for (var i = 0; i < 32; i++) {
        uid[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      uid[6] = '4'
      uid[15] = hexDigits.substr((uid[15] & 0x3) | 0x8, 1)
      var uuid = uid.join('')
      return uuid
    },
    getBit(n, k) { // MQTT
      var bx = false
      if (((n >> k) & 1) == 1) {
        bx = true
      } else {
        bx = false
      }
      return bx
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.changePieBtn {
  outline: none; //消除默认点击蓝色边框效果
  height: 25px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #c2e7b0;
  background: #f0f9eb;
  margin-bottom: 10px;
  position: relative;
  margin-left: calc(1% + 5px);
}
.active {
  border: 1px solid #67c23a;
  background: #67c23a;
  color: white;
}
.questionPop {
  display: none;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  bottom: 165px;
  left: 10px;
  max-width: 100%;
}
.card-panel {
  padding-bottom: 20px;
}
.blockContentDiv {
  padding: 0 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.deviceInfoChart {
  width: 49%;
  display: inline-block;
  // border:1px solid red;
  height: 250px;
}
.deviceInfoDetail {
  width: 100%;
  line-height: 43px;
  // border:1px solid red;
}
.deviceInfoDetailP {
  line-height: 43px;
  position: relative;
}
.hadHourMeter .deviceInfoDetailP {
  line-height: 32px;
}
.hadServiceEndTime .deviceInfoDetailP{
  line-height: 37px;
}
.hadServiceEndTime.hadHourMeter .deviceInfoDetailP{
  line-height: 29px;
}
.deviceInfoDetailBtn {
  position: absolute;
  right: 0;
}
.statusContentWarp {
  height: 100%;
  // border:1px solid red;
}
.warningWrap {
  // height: 250px;
  padding: 15px 5%;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  // justify-content: space-around;
  text-align: center;
  overflow-y: auto;
}
.warningDivs {
  display: inline-block;
}
.warningImg {
  width: 70px;
  height: 70px;
  display: inline-block;
}
.redWarningRadiu {
  font-size: 20px;
  margin-top: 5px;
  width: 10px;
  height: 10px;
  display: inline-block;
  position: absolute;
  z-index: 200;
  background: red;
  border-radius: 50%;
  // left: calc(50% + 15px);
  // top: 0px;
  right: 18px;
  top: 2px;
}
.redRadiu {
  display: inline-block;
  width: 13px;
  height: 13px;
  background: #ca6a6a;
  border-radius: 50%;
  position: absolute;
  top: 13px;
  left: -17px;
}
.feedBackBtn {
  position: absolute;
  right: 90px;
  background: #f0bd29;
  border: 1px solid #f0bd29;
}

.p_row {
  .p_col {
    width: 50%;
  }
  .p_col:nth-child(odd) {
    padding-right: 10px;
  }
  .p_col:nth-child(even) {
    padding-left: 10px;
  }
}
.map_box {
  padding: 20px;
  background-color: #fff;
  position: relative;
  margin-bottom: 20px;
  .check_box {
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 999;
  }
}
</style>
<style lang="scss">
#allDeviceDetail {
  .el-form-item {
    width: 100%;
    position: relative;
  }
  .el-form-item__content {
    width: calc(100% - 180px);
  }
  .el-autocomplete,
  .el-cascader--medium,
  .el-input {
    width: 100% !important;
  }
  .ycdd .el-input {
    width: 80px !important;
    margin-right: 10px;
  }
  .ycdd .el-input__inner {
    padding: 0 10px;
  }
  .el-dialog {
    margin-top: 5vh !important;
  }
  .el-select {
    width: 100%;
  }
  .el-select-dropdown__item.selected {
    color: #606266;
    font-weight: normal;
  }
  .setting .el-form-item__label {
    color: #1990fc;
  }
  // .el-row {
  //   padding-right: 30px;
  // }
  .cellNumberInfoPop {
    display: inline-block;
    background: white;
    padding: 14px;
    vertical-align: top;
    box-shadow: 1px 1px 5px #ccc;
    position: absolute;
    z-index: 999;
    bottom: 64px;
    max-width: 100%;
    right: 0;
    width: auto;
  }
  .cellNumber {
    position: relative;
  }
  .cellNumber .el-icon-question {
    position: absolute;
    top: 7px;
    font-size: 18px;
    color: #858585;
    z-index: 999;
    right: -20px;
  }
  .fullChargeTime .el-input {
    width: 80% !important;
  }
}
</style>

